import { OBJECTIVES_ONLINE_DISPONIBILIDAD } from '../../../utils/storageNames';

/**
 * Obtiene el ID del paso predeterminado (el primero) asociado a un objetivo específico.
 * 
 * Esta función busca en el `sessionStorage` (bajo la clave `OBJECTIVES_ONLINE_DISPONIBILIDAD`)
 * una lista de objetivos clasificados por estado (Uptime, Partial, Downtime, NoMonitoring).
 * Si encuentra el objetivo coincidente con el `objetivoId` proporcionado, devuelve el ID de su primer paso.
 *
 * @param {Object} params - Objeto de parámetros.
 * @param {number|string} params.objetivoId - El ID único del objetivo que se desea buscar.
 * @returns {number} El ID del primer paso (`id_paso`) si existe, o `0` si no se encuentra el objetivo, no tiene pasos, o no hay datos en el almacenamiento.
 * 
 * @author David Maldonado
 * (c) Servicios de Monitoreo S.A. - Santiago, Chile
 */
export function getObjetivoDefaultStep({ objetivoId }) {
  const objectivesStorage = sessionStorage.getItem(
    OBJECTIVES_ONLINE_DISPONIBILIDAD
  );
  const objectivesStorageParse = objectivesStorage
    ? JSON.parse(objectivesStorage)
    : null;
  if (!objectivesStorageParse) {
    return 0;
  }
  const allObjectives = [
    ...(objectivesStorageParse?.Uptime ?? []),
    ...(objectivesStorageParse?.Partial ?? []),
    ...(objectivesStorageParse?.Downtime ?? []),
    ...(objectivesStorageParse?.NoMonitoring ?? []),
  ];

  const pasosObjetivos = allObjectives.find(
    (obj) => obj.objetivo_id === objetivoId
  );

  if (!pasosObjetivos || !pasosObjetivos.Pasos) {
    return 0;
  }
  return pasosObjetivos.Pasos.length > 0
    ? Number(pasosObjetivos.Pasos[0].id_paso)
    : 0;
}
